"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "costigliole-d-asti": {
    "22980d02": [{
      "hkey": "15eafd6c",
      "slug": "bionzo",
      "name": "Bionzo",
      "primary": true,
      "skipSearch": false
    }],
    "bionzio": [{
      "hkey": "15eafd6c",
      "slug": "bionzo",
      "name": "Bionzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "607e7b95": [{
      "hkey": "cd1492c7",
      "slug": "costigliole-d-asti",
      "name": "Costigliole d'Asti",
      "primary": true,
      "skipSearch": false
    }],
    "burio": [{
      "hkey": "cd1492c7",
      "slug": "costigliole-d-asti",
      "name": "Costigliole d'Asti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6f41decd": [{
      "hkey": "cd1492c7",
      "slug": "costigliole-d-asti",
      "name": "Costigliole d'Asti",
      "primary": true,
      "skipSearch": false
    }],
    "san-michele": [{
      "hkey": "cd1492c7",
      "slug": "costigliole-d-asti",
      "name": "Costigliole d'Asti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;